import { createElement, memo } from '@max/max';
import TopView from '@max/leez-top-view';
import ModalBaseContainer from '@max/leez-modal-base-container';
import { getFullScreenSize } from '@/utils/layout';
import View from '@hfe/max-view';
import Button from '@hfe/max-button';
import LImage from '@max/leez-image';
import './index.scss';
import Content from './content';
const ModalBase = (props) => {
    const { visible, onClose, onLxReport, onCityPress, onTeamPress } = props;
    const { fullScreenHeight, fullScreenWidth } = getFullScreenSize();
    return <>
      <TopView>
        <ModalBaseContainer visible={visible} onMaskPress={onClose} type="fade" contentStyle={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: fullScreenHeight,
        width: fullScreenWidth
    }}>
          <View className="modal-base-wrap">
            <Content onCityPress={onCityPress} onTeamPress={onTeamPress}/>
          </View>
          <Button className="modal-base-close-btn" onPress={onClose}>
            <LImage source={{
        uri: 'https://p0.meituan.net/ingee/e856a5b58953206e87335897d397d9bf1641.png'
    }} style={{
        width: '48rpx',
        height: '48rpx'
    }}/>
          </Button>
        </ModalBaseContainer>
    </TopView>
  </>;
};
export default memo(ModalBase);
